/** MapLibreで指定できる地図のデータソースの種別 */
export const MAP_SOURCE_TYPE = {
  VECTOR: 'vector',
  RASTER: 'raster',
  RASTER_DEM: 'raster-dem',
  GEOJSON: 'geojson',
  IMAGE: 'image',
  VIDEO: 'video',
  CANVAS: 'canvas',
  FILL: 'fill',
  LINE: 'line',
  SYMBOL: 'symbol'
} as const
